import { WorldCountry } from '../types';
import { vietnamAdditionalCities } from './vietnamExpansion';

export const southeastAsiaData: WorldCountry[] = [
  {
    name: 'Indonesia',
    slug: 'indonesia',
    code: 'ID',
    population: 273523615,
    topCities: [
      { name: 'Jakarta', slug: 'jakarta', population: 10770487 },
      { name: 'Surabaya', slug: 'surabaya', population: 2874699 },
      { name: 'Medan', slug: 'medan', population: 2435252 },
      { name: 'Bekasi', slug: 'bekasi', population: 2543676 },
      { name: 'Bandung', slug: 'bandung', population: 2444160 },
      { name: 'Tangerang', slug: 'tangerang', population: 2139891 },
      { name: 'Depok', slug: 'depok', population: 2056335 },
      { name: 'Semarang', slug: 'semarang', population: 1653524 },
      { name: 'Palembang', slug: 'palembang', population: 1668848 },
      { name: 'Makassar', slug: 'makassar', population: 1423877 }
    ]
  },
  {
    name: 'Philippines',
    slug: 'philippines',
    code: 'PH',
    population: 109581078,
    topCities: [
      { name: 'Manila', slug: 'manila', population: 1780148 },
      { name: 'Quezon City', slug: 'quezon-city', population: 2936116 },
      { name: 'Caloocan', slug: 'caloocan', population: 1661584 },
      { name: 'Davao City', slug: 'davao-city', population: 1776949 },
      { name: 'Cebu City', slug: 'cebu-city', population: 964169 },
      { name: 'Zamboanga City', slug: 'zamboanga-city', population: 977234 },
      { name: 'Antipolo', slug: 'antipolo', population: 887399 },
      { name: 'Taguig', slug: 'taguig', population: 886722 },
      { name: 'Pasig', slug: 'pasig', population: 803159 },
      { name: 'Cagayan de Oro', slug: 'cagayan-de-oro', population: 728402 }
    ]
  },
  {
    name: 'Malaysia',
    slug: 'malaysia',
    code: 'MY',
    population: 32365999,
    topCities: [
      { name: 'Kuala Lumpur', slug: 'kuala-lumpur', population: 1768000 },
      { name: 'George Town', slug: 'george-town-malaysia', population: 708127 },
      { name: 'Ipoh', slug: 'ipoh', population: 657892 },
      { name: 'Shah Alam', slug: 'shah-alam', population: 617489 },
      { name: 'Petaling Jaya', slug: 'petaling-jaya', population: 613977 },
      { name: 'Johor Bahru', slug: 'johor-bahru', population: 497067 },
      { name: 'Seremban', slug: 'seremban', population: 372917 },
      { name: 'Kuantan', slug: 'kuantan', population: 366229 },
      { name: 'Iskandar Puteri', slug: 'iskandar-puteri', population: 529074 },
      { name: 'Kajang', slug: 'kajang', population: 342657 }
    ]
  },
  {
    name: 'Singapore',
    slug: 'singapore',
    code: 'SG',
    population: 5850342,
    topCities: [
      { name: 'Singapore', slug: 'singapore-city', population: 5850342 },
      { name: 'Jurong East', slug: 'jurong-east', population: 300000 },
      { name: 'Tampines', slug: 'tampines', population: 284000 },
      { name: 'Woodlands', slug: 'woodlands-singapore', population: 254000 },
      { name: 'Sengkang', slug: 'sengkang', population: 249000 },
      { name: 'Hougang', slug: 'hougang', population: 226000 },
      { name: 'Yishun', slug: 'yishun', population: 220000 },
      { name: 'Bedok', slug: 'bedok', population: 289000 },
      { name: 'Ang Mo Kio', slug: 'ang-mo-kio', population: 174000 },
      { name: 'Toa Payoh', slug: 'toa-payoh', population: 126000 }
    ]
  },
  {
    name: 'Brunei',
    slug: 'brunei',
    code: 'BN',
    population: 437479,
    topCities: [
      { name: 'Bandar Seri Begawan', slug: 'bandar-seri-begawan', population: 100700 },
      { name: 'Kuala Belait', slug: 'kuala-belait', population: 31178 },
      { name: 'Seria', slug: 'seria', population: 23639 },
      { name: 'Tutong', slug: 'tutong', population: 19151 },
      { name: 'Bangar', slug: 'bangar', population: 3000 },
      { name: 'Muara', slug: 'muara', population: 8000 },
      { name: 'Labi', slug: 'labi', population: 1200 },
      { name: 'Lumapas', slug: 'lumapas', population: 3500 },
      { name: 'Gadong', slug: 'gadong', population: 15000 },
      { name: 'Jerudong', slug: 'jerudong', population: 8000 }
    ]
  },
  {
    name: 'East Timor',
    slug: 'east-timor',
    code: 'TL',
    population: 1318445,
    topCities: [
      { name: 'Dili', slug: 'dili', population: 277279 },
      { name: 'Maliana', slug: 'maliana', population: 22000 },
      { name: 'Suai', slug: 'suai', population: 23000 },
      { name: 'Lospalos', slug: 'lospalos', population: 17186 },
      { name: 'Aileu', slug: 'aileu', population: 17356 },
      { name: 'Same', slug: 'same-timor', population: 25411 },
      { name: 'Viqueque', slug: 'viqueque', population: 23548 },
      { name: 'Baucau', slug: 'baucau', population: 16000 },
      { name: 'Ermera', slug: 'ermera', population: 8907 },
      { name: 'Liquiçá', slug: 'liquica', population: 9667 }
    ]
  },
  {
    name: 'Vietnam',
    slug: 'vietnam',
    code: 'VN',
    population: 98168000,
    topCities: [
      { name: 'Ho Chi Minh City', slug: 'ho-chi-minh-city', population: 9077000 },
      { name: 'Hanoi', slug: 'hanoi', population: 8053000 },
      { name: 'Hai Phong', slug: 'hai-phong', population: 2028000 },
      { name: 'Da Nang', slug: 'da-nang', population: 1230000 },
      { name: 'Can Tho', slug: 'can-tho', population: 1238000 },
      { name: 'Bien Hoa', slug: 'bien-hoa', population: 1104000 },
      { name: 'Hue', slug: 'hue', population: 455230 },
      { name: 'Nha Trang', slug: 'nha-trang', population: 423000 },
      { name: 'Buon Ma Thuot', slug: 'buon-ma-thuot', population: 340000 },
      { name: 'Vung Tau', slug: 'vung-tau', population: 327000 },
      ...vietnamAdditionalCities
    ]
  },
  {
    name: 'Thailand',
    slug: 'thailand',
    code: 'TH',
    population: 69799978,
    topCities: [
      { name: 'Bangkok', slug: 'bangkok', population: 10539000 },
      { name: 'Nonthaburi', slug: 'nonthaburi', population: 254375 },
      { name: 'Pak Kret', slug: 'pak-kret', population: 196402 },
      { name: 'Hat Yai', slug: 'hat-yai', population: 157678 },
      { name: 'Chiang Mai', slug: 'chiang-mai', population: 127000 },
      { name: 'Laem Chabang', slug: 'laem-chabang', population: 79546 },
      { name: 'Udon Thani', slug: 'udon-thani', population: 142670 },
      { name: 'Surat Thani', slug: 'surat-thani', population: 127201 },
      { name: 'Khon Kaen', slug: 'khon-kaen', population: 147579 },
      { name: 'Nakhon Ratchasima', slug: 'nakhon-ratchasima', population: 204391 }
    ]
  },
  {
    name: 'Myanmar',
    slug: 'myanmar',
    code: 'MM',
    population: 54409800,
    topCities: [
      { name: 'Yangon', slug: 'yangon', population: 5142000 },
      { name: 'Mandalay', slug: 'mandalay', population: 1225553 },
      { name: 'Naypyidaw', slug: 'naypyidaw', population: 924608 },
      { name: 'Mawlamyine', slug: 'mawlamyine', population: 451100 },
      { name: 'Bago', slug: 'bago', population: 284665 },
      { name: 'Pathein', slug: 'pathein', population: 237089 },
      { name: 'Monywa', slug: 'monywa', population: 182011 },
      { name: 'Sittwe', slug: 'sittwe', population: 180700 },
      { name: 'Taunggyi', slug: 'taunggyi', population: 131500 },
      { name: 'Myingyan', slug: 'myingyan', population: 111431 }
    ]
  },
  {
    name: 'Cambodia',
    slug: 'cambodia',
    code: 'KH',
    population: 16718965,
    topCities: [
      { name: 'Phnom Penh', slug: 'phnom-penh', population: 2281951 },
      { name: 'Kandal', slug: 'kandal', population: 1265085 },
      { name: 'Sihanoukville', slug: 'sihanoukville', population: 221328 },
      { name: 'Battambang', slug: 'battambang', population: 196709 },
      { name: 'Siem Reap', slug: 'siem-reap', population: 171889 },
      { name: 'Kampong Cham', slug: 'kampong-cham', population: 61752 },
      { name: 'Pursat', slug: 'pursat', population: 57522 },
      { name: 'Ta Khmau', slug: 'ta-khmau', population: 48442 },
      { name: 'Paoy Pet', slug: 'paoy-pet', population: 43366 },
      { name: 'Sisophon', slug: 'sisophon', population: 39843 }
    ]
  },
  {
    name: 'Laos',
    slug: 'laos',
    code: 'LA',
    population: 7337198,
    topCities: [
      { name: 'Vientiane', slug: 'vientiane', population: 948000 },
      { name: 'Pakse', slug: 'pakse', population: 88000 },
      { name: 'Savannakhet', slug: 'savannakhet', population: 66000 },
      { name: 'Luang Prabang', slug: 'luang-prabang', population: 55000 },
      { name: 'Xam Neua', slug: 'xam-neua', population: 47000 },
      { name: 'Thakhek', slug: 'thakhek', population: 40000 },
      { name: 'Muang Xay', slug: 'muang-xay', population: 37000 },
      { name: 'Phonsavan', slug: 'phonsavan', population: 37000 },
      { name: 'Vang Vieng', slug: 'vang-vieng', population: 25000 },
      { name: 'Sayaboury', slug: 'sayaboury', population: 20000 }
    ]
  }
];
